import { useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import translate from "i18n/translate";
import { intialFormOptions } from "./constants";
import CreateForm from "./CreateForm";
import { useStyles } from "../applicationStyles";
import ApplicationKey from "../ApplicationKey";
import { SrDialog, Typography } from "../../../../common";
import ApplicationSquareButton from "../ApplicationSquareButton";
import { IOS, NEW_SHOPIFY, ECOMMERCE, ANDROID } from "../../../../../constants";

const Create = ({
  handleClose,
  onSubmit,
  secretKey,
  loading,
  error,
  clearError,
}) => {
  const classes = useStyles();
  const [form, setForm] = useState();

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const resetForm = () => {
    setForm();
    clearError();
  };

  return (
    <SrDialog
      heading={translate("applications.newApp.field")}
      handleClose={handleClose}
      size={"sm"}
    >
      {!form && !secretKey ? (
        <Grid container>
          <Grid item xs={12}>
            <Grid item style={{ padding: "30px 0px" }}>
              <Typography align="center" variant="h4Regular">
                {translate("applications.platformSelect")}
              </Typography>
            </Grid>
            <Box margin="20px 0 40px 0">
              <Grid item container spacing={4} justifyContent="center">
                <Grid
                  item
                  container
                  justifyContent={matches ? "center" : "flex-end"}
                  spacing={4}
                  xs={12}
                  md={6}
                >
                  <Grid item>
                    <ApplicationSquareButton
                      className={classes.squareCreateButton}
                      onClick={() => setForm(intialFormOptions[ECOMMERCE])}
                      applicationType={ECOMMERCE}
                    />
                  </Grid>
                  <Grid item>
                    <ApplicationSquareButton
                      className={classes.squareCreateButton}
                      onClick={() => setForm(intialFormOptions[IOS])}
                      applicationType={IOS}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  container
                  justifyContent={matches ? "center" : "flex-start"}
                  spacing={4}
                  xs={12}
                  md={6}
                >
                  <Grid item>
                    <ApplicationSquareButton
                      className={classes.squareCreateButton}
                      onClick={() => setForm(intialFormOptions[ANDROID])}
                      applicationType={ANDROID}
                    />
                  </Grid>
                  <Grid item>
                    <ApplicationSquareButton
                      className={classes.squareCreateButton}
                      onClick={() => setForm(intialFormOptions[NEW_SHOPIFY])}
                      applicationType={NEW_SHOPIFY}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      ) : (
        <>
          {!secretKey ? (
            <Grid container>
              <CreateForm
                resetForm={resetForm}
                form={form}
                onSubmit={(values) => onSubmit(values)}
                loading={loading}
                error={error}
              />
            </Grid>
          ) : (
            <ApplicationKey secretKey={secretKey} />
          )}
        </>
      )}
    </SrDialog>
  );
};

Create.propTypes = {
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  clearError: PropTypes.func.isRequired,
  secretKey: PropTypes.string,
  error: PropTypes.string,
};

Create.defaultProps = {
  secretKey: undefined,
  error: undefined,
};

export default Create;
